<template>
  <div>
    <cc-collapse :title="$t('ct-sizes')">
      <cc-slider-component ref="heightConfig"></cc-slider-component>
      <cc-slider-component ref="minHeightConfig"></cc-slider-component>
    </cc-collapse>

    <cc-collapse v-show="!isPopup()" :title="$t('ct-border')">
      <cc-border-component
        ref="border"
        :customWidth="true"
      ></cc-border-component>
    </cc-collapse>

    <cc-collapse v-show="!isPopup()" :title="$t('ct-sliderInfinitePanel')">
      <div style="margin: 5px">
        <input
          id="checkbox-infiniteSlider"
          type="checkbox"
          v-model="infiniteSlider"
          @change="setinfiniteSliderAnimation"
        />
        <label for="checkbox-infiniteSlider">{{$t('ct-enable')}}</label>
      </div>
    </cc-collapse>

    <cc-collapse v-show="!isPopup()" :title="$t('ct-arrowConfig')">
      <cc-arrow-config ref="arrowConfig"></cc-arrow-config>
    </cc-collapse>

    <cc-collapse
      v-show="!isPopup() && notGlobalItem() && !config.separatorActive"
      :title="$t('ct-hidePanel')"
    >
      <div class="form-group">
        <toggle-button-component
          :checked="config.hidePanel"
          @change="setHide"
          color="information"
        />
        <span v-text="$t('ct-enable')"/>
      </div>
      <div v-show="config.hidePanel" class="form-group">
        <label for="">{{ $t("ct-type") }} </label>
        <select
          name=""
          id=""
          v-model="config.typeHidePanel"
          class="form-control"
          @change="save()"
        >
          <option :value="'time'">{{ $t("ct-time") }}</option>
          <option :value="'action'">{{ $t("ct-action") }}</option>
        </select>
      </div>
      <div
        v-show="config.hidePanel && config.typeHidePanel === 'time'"
        class="form-group"
      >
        <div class="row">
          <div class="col-6">
            <label for=""> {{ $t("ct-minutes") }} 0 - 360 </label>
            <input
              type="number"
              min="0"
              max="350"
              class="form-control"
              v-model="minutesSaved"
            />
          </div>
          <div class="col-6">
            <label for=""> {{ $t("ct-seconds") }} 0 - 59 </label>
            <input
              type="number"
              min="0"
              max="60"
              class="form-control"
              v-model="secondsSaved"
            />
          </div>
          <div class="col-3 offset-7 mt-4">
            <button class="btn btn-success" @click="setHideTime()">Save</button>
          </div>
        </div>
      </div>

      <div
        class="form-group"
        v-show="config.hidePanel && config.typeHidePanel === 'action'"
      >
        <label for="">{{ $t("ct-input-name") }} </label>
        <input
          type="text"
          v-model="config.nameHidePanel"
          class="form-control"
        />
      </div>

      <div
        class="d-flex flex-column m-3"
        v-if="config.hidePanel && config.typeHidePanel === 'action'"
      >
        <button
          class="
            cheetah-button
            cheetah-button-color-success
            cheetah-button-size-large
          "
          @click="setHideName()"
        >
          <i class="fa fa-save"/>
          Save
        </button>
      </div>
      <!--
      <alert-box-component v-show="config.hidePanel && config.typeHidePanel === 'action'" type="warning" :with_icon="false">
        <span
          slot="content"
        > u can use this amazing action everywhere <br> <br>  <strong>    cheetah-panel-show-hide-{{ config.id }} </strong></span>
      </alert-box-component> -->

      <!-- </cc-hide-panel> -->
    </cc-collapse>

    <cc-collapse v-show="!isPopup()" :title="$t('ct-border-radius')">
      <cc-border-radius-component
        ref="borderRadius"
      ></cc-border-radius-component>
    </cc-collapse>

    <cc-collapse v-show="isPopup()" :title="$t('ct-overlay-setting')">
      <div class="form-group">
        <toggle-button-component
          :checked="config.overlayCustom"
          @change="setOverlayCustom"
          color="information"
        />
        <span v-text="$t('ct-enable')"/>
      </div>

      <div v-show="config.overlayCustom">
        <cc-box-color ref="overlayColor"></cc-box-color>
        <div class="form-group">
          <label for="">{{ $t("ct-preview") }}</label>
          <div
            style="
              height: 100px;
              width: 80%;
              margin-left: 10%;
              margin-bottom: 5%;
              border-radius: 5%;
            "
            :style="{ background: config.overlayColor }"
          ></div>
        </div>

        <cc-box-color ref="buttonColor"></cc-box-color>
        <cc-box-color ref="buttonIcon"></cc-box-color>
      </div>
    </cc-collapse>

    <cc-collapse :title="$t('ct-background-settings')">
      <cc-box-color ref="backgroundColor"></cc-box-color>
      <cc-image-component ref="backgroundImage" nameConfig="backgroundImage"></cc-image-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-internal-background-settings')">
      <cc-box-color ref="internalBackgroundColor"></cc-box-color>
      <cc-image-component ref="internalBackgroundImage" nameConfig="internalBackgroundImage"></cc-image-component>
    </cc-collapse>

    <cc-collapse v-show="!isPopup()" :title="$t('ct-video')">
      <cc-video-background ref="video"></cc-video-background>
    </cc-collapse>

    <cc-collapse v-show="!isPopup()" :title="$t('ct-parallax')">
      <cc-parallax ref="parallax"></cc-parallax>
    </cc-collapse>

    <cc-collapse
      v-show="!isPopup() && !config.hidePanel"
      :title="$t('ct-divider')"
    >
      <cc-divider ref="divider"></cc-divider>
    </cc-collapse>

    <cc-collapse :title="$t('ct-tag')">
      <cc-tag ref="tag"></cc-tag>
    </cc-collapse>

    <cc-collapse v-show="!isPopup()" :title="$t('ct-order-panels')">
      <div
        id="sortable-panels"
        style="
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
        "
      >
        <div
          v-for="panel in panelsToMove"
          :key="`panel-move-${panel.id}`"
          class="ordenated-panel"
          :data-id="panel.id"
          :style="{
            height: '50px',
            width: '100px',
            background: panel.background,
            'margin-bottom': '3px',
            border: panel.borderShow,
          }"
        ></div>
      </div>
      <div
        class="sortable-button"
        style="
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          margin-bottom: 15px;
        "
      >
        <button
          style="margin-top: 15px"
          class="btn btn-primary"
          @click="saveOrderPanels"
        >
          {{ $t("ct-move") }}
        </button>
      </div>
    </cc-collapse>

    <cc-collapse v-show="isMobile()" :title="$t('ct-order-elements')">
      <div class="form-group">
        <label class="custom-label" v-text="$t('ct-order-elements')"/>
        <ul id="sortable-childs">
          <li
            @mouseover="hoverOver(child)"
            @mouseout="hoverOut(child)"
            class="sortable-child-reorder"
            :data-child-id="child.id"
            :data-child-name="child.name"
            v-for="child in childs.filter((c) => c.config.showMobile)"
            :key="child.id"
          >
            <font-awesome-icon
              class="font-awesome-icon"
              :icon="['fas', 'eye']"
            />
            <i
              class="mdi element-icon"
              :class="componentIcons[child.name] || 'mdi-checkbox-blank-circle'"
            />
            {{ $t(`ct-component-${child.name}`).replace("Component", "") }}
          </li>
        </ul>
        <div style="display: flex; justify-content: center">
          <button @click="saveChildsOrder" class="btn btn-primary small center">
            {{ $t("ct-move") }}
          </button>
        </div>
      </div>
      <div class="form-group">
        <label class="custom-label" v-text="$t('ct-hidden-elements')"/>
        <ul id="sortable-hidden-childs">
          <li
            class="sortable-child-reorder hidden-elements"
            :data-child-id="child.id"
            :data-child-name="child.name"
            v-for="child in childs.filter((c) => !c.config.showMobile)"
            :key="child.id"
          >
            <font-awesome-icon
              class="font-awesome-icon"
              :icon="['fas', 'eye-slash']"
            />
            <i
              class="mdi element-icon"
              :class="componentIcons[child.name] || 'mdi-checkbox-blank-circle'"
            />
            {{ $t(`ct-component-${child.name}`).replace("Component", "") }}
          </li>
        </ul>
      </div>
    </cc-collapse>

    <cc-collapse v-show="!isPopup()" :title="$t('ct-mobile-columns')">
      <div class="form-group">
        <toggle-button-component
          :checked="config.columns"
          @change="toggleColuns"
          color="information"
        />
        <span v-text="$t('ct-enable')"/>
      </div>
      <div v-show="config.columns" class="form-group">
        <label for="">{{ $t("ct-grid") }} </label>
        <select
          name=""
          id=""
          v-model="config.columns_count"
          class="form-control"
          @change="toggleColuns"
        >
          <option :value="2">2</option>
          <option :value="3">3</option>
        </select>
      </div>
      <alert-box-component type="warning" :with_icon="true">
        <span slot="content" v-text="$t('ct-mobile-columns-helper')"/>
      </alert-box-component>
    </cc-collapse>

    <cc-collapse :title="'Tags mboss'">

      <div class="form-group">
        <toggle-button-component
          :checked="config.enable_tags"
          @change="toggleEnableTags"
          color="information"
        />
        <span v-text="$t('ct-enable')"/>
      </div>
      <alert-box-component type="warning" :with_icon="true">
        <span
          slot="content"
          v-text="$t('ct-tag-mboss-helper')"
        />
      </alert-box-component>
      <div>
        <ul class="form-group">
          <li v-for="(tag, index) in config.enabled_tags" :key="index">
            <i @click="removeEnabledTag(index)" class="fa fa-window-close"></i>
            {{ tag.column + ' - ' + tag.operator + ' - ' + tag.value }}
          </li>
        </ul>
      </div>
      <div class="form-group">
        <label for="">Tag</label>
        <input v-model="enable_tags.column" required type="text" class="form-control">
      </div>
      <div class="form-group">
        <label for="">Operator</label>
        <select v-model="enable_tags.operator" required class="form-control">
          <option value="equal" selected v-text="$t('ct-equal')"></option>
          <option value="bigger" v-text="$t('ct-bigger')"></option>
          <option value="smaller" v-text="$t('ct-smaller')"></option>
        </select>
      </div>
      <div class="form-group">
        <label for="">Value</label>
        <input v-model="enable_tags.value" required type="text" class="form-control">
      </div>
      <div style="display: flex; justify-content: center; ">
        <button @click="addTagPanel" class="btn btn-primary small center">{{ $t('ct-save') }}</button>
      </div>

    </cc-collapse>

    <cc-collapse :title="$t('ct-fixed')" v-show="firstPanel && !isPopup()">
      <label style="padding-left: 15px" class="custom-label">{{
          $t("ct-sticky-header")
        }}</label>
      <div class="form" style="padding-left: 15px">
        <label style="width: 250px">
          <input
            type="checkbox"
            v-model="fixedActive"
            @change="setFixed"
            @keyup="setFixed"
          />
          {{ $t("ct-active-desktop") }}
        </label>
        <label style="width: 250px">
          <input
            type="checkbox"
            v-model="fixedMobileActive"
            @change="setFixed"
            @keyup="setFixed"
          />
          {{ $t("ct-active-mobile") }}
        </label>
      </div>
    </cc-collapse>

    <cc-collapse v-show="!isPopup()" :title="$t('ct-anchor')">
      <cc-anchor ref="anchor"></cc-anchor>
    </cc-collapse>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import ToggleButtonComponent from "../../../commons/ToggleButtonComponent";
import AlertBoxComponent from "../../../commons/AlertBoxComponent";
import InputRange from "../../resource_components/Abstract/InputRange";

export default {
  name: "Options",
  components: {
    ToggleButtonComponent,
    AlertBoxComponent,
    InputRange,
  },
  data() {
    return {
      config: {},
      childs: [],
      enable_tags: {
        'column': '',
        'value': '',
        'operator': 'equal',
      },
      childOrder: [],
      panelsToMove: [],
      fixedActive: false,
      infiniteSlider: false,
      fixedMobileActive: false,
      hidePanel: false,
      timeHidePanel: false,
      sortable: false,
      firstPanel: false,
      maxTime: 300,
      callback: () => {
      },
      minutesSaved: 0,
      secondsSaved: 0,
      componentIcons: {
        TextComponent: "mdi-text-subject",
        AccordionGroupComponent: "mdi-plus-box-multiple-outline",
        CounterTextComponent: "mdi-animation-play",
        GroupMenuComponent: "mdi-menu-open",
        BookingCalendarComponent: "mdi-calendar",
        BoxComponent: "mdi-checkbox-blank",
        ButtonComponent: "mdi-rectangle",
        SimpleFormComponent: "mdi-contact-mail",
        MultiStepFormComponent: "mdi-contact-mail",
        MailingBossFormComponent: "mdi-email-newsletter",
        SliderGalleryComponent: "mdi-image-multiple",
        GetResponseFormComponent: "mdi-email-newsletter",
        IframeComponent: "mdi-code-tags",
        ImageComponent: "mdi-image",
        LineComponent: "mdi-vector-line",
        MenuComponent: "mdi-xbox-controller-menu",
        SliderGroupComponent: "mdi-move-resize-variant",
        SocialBarComponent: "mdi-facebook",
        TimerComponent: "mdi-clock",
        YoutubeVideoComponent: "mdi-message-video",
        VimeoVideoComponent: "mdi-message-video",
        WistiaVideoComponent: "mdi-message-video",
        VidelloVideoComponent: "mdi-message-video",
        VideoGalleryGroupComponent: "mdi-message-video",
        WebinarVideoComponent: "mdi-monitor-clean",
      },
    };
  },
  methods: {
    isMobile() {
      try {
        return document
          .querySelectorAll("[data-device]")[1]
          .getAttribute("data-device") === "mobile"
          ? true
          : false;
      } catch (e) {
        console.log(e);
      }
      return false;
    },
    isPopup() {
      if (window.location.href.indexOf('editor-layout-item/popup/') !== -1) {
        return true;
      } else {
        return false;
      }
    },
    isFooter() {
      if (window.location.href.indexOf('editor-layout-item/footer/') === -1) {
        return true;
      } else {
        return false;
      }
    },
    notGlobalItem() {
      if (
        window.location.href.indexOf("editor-layout-item/header/") === -1 &&
        window.location.href.indexOf("editor-layout-item/footer/") === -1
      ) {
        return true;
      } else {
        return false;
      }
    },
    setOverlayCustom(value) {
      this.config.overlayCustom = value;
      this.save();
    },
    hoverOver(elm) {
      const element = document.getElementById(elm.id);
      element.style.border = "3px dashed #0080FC";

      const badge = document.createElement("span");
      badge.classList += "badge badge-primary float-right badge-order-cheetah";
      badge.style.display = "block";
      badge.innerHTML = this.$t("ct-selected-element");

      const vdr = element.querySelectorAll(".vdr")[0];
      vdr.insertBefore(badge, vdr.firstChild);

      let child_length = this.childOrder.length;

      if (child_length === 0) {
        this.orderChilds();
      }
    },
    hoverOut(elm) {
      const badges = document.querySelectorAll(
        ".badge-primary.badge-order-cheetah"
      );
      badges.forEach((badge) => {
        badge.remove();
      });

      const element = document.getElementById(elm.id);
      element.style.border = null;
    },
    saveChildsOrder() {
      let arr = [];
      let vm = this;
      let childs = document.getElementById("sortable-childs");
      childs.children.forEach((child, idx) =>
        arr.push({
          id: child.getAttribute("data-child-id"),
          name: child.getAttribute("data-child-name"),
          order: idx,
        })
      );
      childs = document.getElementById("sortable-hidden-childs");
      childs.children.forEach((child, idx) =>
        arr.push({
          id: child.getAttribute("data-child-id"),
          name: child.getAttribute("data-child-name"),
          order: idx,
        })
      );
      vm.childOrder = arr;
      vm.callback({orderElementsConfig: true, data: arr});
    },
    increaseOrder(id) {
      let vm = this;

      let child_lenght = vm.childOrder.length;
      let child_to_move = {};

      if (child_lenght === 0) {
        vm.orderChilds();
      }

      child_lenght = vm.childOrder.length;
      let ordeNated = [];

      for (let i = 0; i < child_lenght; i++) {
        vm.childOrder.forEach((child) => {
          if (child.order === i) {
            ordeNated.push(child);
          }
          if (child.id === id) {
            child_to_move = child;
            child_to_move.order++;
          }
        });
      }
      let arr = [];

      ordeNated.forEach((child, idx) => {
        if (child.order > child_to_move.order || child.id === id) {
          child.order++;
        }

        arr.push(child);
      });
    },
    orderChilds() {
      let vm = this;
      vm.childOrder = [];
      //tratamento childs temporario
      vm.childs.forEach((child, idx) => {
        vm.childOrder.push({
          id: child.id,
          order: child.config.order_mobile,
          name: child.name,
        });

        //  <span class="badge badge-primary float-right">1</span>
      });

      this.attachBadge();

      var el = document.getElementById("sortable-childs");
      this.sortable = Sortable.create(el);
    },
    attachBadge() {
      let badges = document.querySelectorAll(".badge-order-cheetah");

      badges.forEach((badge) => {
        badge.remove();
      });

      let vm = this;
      //  vm.childOrder.forEach(child => {
      //   let element = document.getElementById(child.id);
      //   let vdr = element.querySelectorAll('.vdr')[0]
      //   let badge = document.createElement('span');
      //   badge.classList += 'badge badge-primary float-right badge-order-cheetah';
      //   badge.innerHTML = child.order + 1;

      //   vdr.insertBefore(badge, vdr.firstChild)
      //  })
    },
    saveOrderPanels() {
      let panels = document.querySelectorAll(
        "#sortable-panels > .ordenated-panel"
      );
      let ordenatedArray = [];

      panels.forEach((panel) => {
        ordenatedArray.push(panel.getAttribute("data-id"));
      });

      this.$parent.changeOrderPanel(ordenatedArray);
    },
    makePanelsToOrder() {
      let vm = this;
      this.panelsToMove = [];

      function _newElement(element) {
        let obj = {
          id: element.getAttribute("id"),
          config: JSON.parse(element.getAttribute("config-properties")),
        };

        let bg = obj.config.backgroundColor;

        if (
          obj.config.backgroundImage !== "none" &&
          typeof obj.config.backgroundImage !== "undefined"
        ) {

          bg += ' url("' + obj.config.backgroundImage + '")';
          bg += " " + obj.config.backgroundPosition;
          bg += " / " + obj.config.backgroundSize;
          bg += " " + obj.config.backgroundRepeat;
          bg += " " + obj.config.backgroundOrigin;
          if (typeof obj.config.backgroundAttachment !== "undefined")
            bg += " " + obj.config.backgroundAttachment;
        }

        obj.background = bg;

        if (obj.id === vm.config.id) {
          obj.borderShow = "3px solid #007FFC";
        } else {
          obj.borderShow = "none";
        }

        return obj;
      }

      let elementsToSave = [];
      let panels = document.querySelectorAll(
        '#editor-content > [element="PanelComponent"]  > [element="PanelComponent"]'
      );

      panels.forEach((panel, index) => {
        if (index === 0) {
          if (panel.getAttribute("id") === vm.config.id) {
            vm.firstPanel = true;
          }
        }
        elementsToSave.push(_newElement(panel));
      });

      this.panelsToMove = elementsToSave;

      var el = document.getElementById("sortable-panels");
      this.sortable = Sortable.create(el);
    },

    init(config, childs, callback) {
      let vm = this;
      vm.firstPanel = false;

      vm.config = _.clone(config);
      vm.childs = _.clone(childs);
      vm.callback = callback;
      this.makePanelsToOrder();

      //fixed
      vm.fixedActive = vm.config.fixed;
      vm.fixedMobileActive = vm.config.fixedMobile;

      //anchor
      this.$refs["anchor"].setValues({
        anchorActive: vm.config.anchorActive,
        anchorName: vm.config.anchorName,
        labelDesc: "anchor",
        name: "anchor",
        callback: vm.setAnchor,
      });

      //arrow
      this.$refs["arrowConfig"].setValues({
        defaultArrowActive: vm.config.arrowActive,
        defaultArrowWidth: vm.config.arrowWidth,
        defaultArrowWidthMobile: vm.config.arrowWidthMobile,
        defaultArrowHeight: vm.config.arrowHeight,
        defaultArrowColor: vm.config.arrowColor,
        labelDesc: "arrowConfig",
        name: "arrowConfig",
        callback: vm.setArrow,
      });

      //slider animation panel
      vm.infiniteSlider = vm.config.infiniteSliderAnimation

      // //hidePanel
      vm.hidePanel = vm.config.hidePanel;
      vm.timeHidePanel = vm.config.timeHidePanel;

      if (vm.config.nameHidePanel === "name-hide-panel") {
        vm.config.nameHidePanel = `panel-${new Date().getTime() / 1000}`;
        vm.config.nameHidePanel = vm.config.nameHidePanel.replace(
          /[^\w\s]/gi,
          ""
        );
      }

      //sizes
      this.$refs["heightConfig"].setValues({
        defaultValue: vm.config.height,
        defaultValueChecked: true,
        min: 50,
        max: 7000,
        canBeCheckbox: false,
        labelDesc: "height",
        name: "iconColor",
        callback: vm.setHeight,
      });
      this.$refs["minHeightConfig"].setValues({
        defaultValue: vm.config.minHeight,
        defaultValueChecked: true,
        min: 50,
        max: 800,
        canBeCheckbox: false,
        labelDesc: "min-height",
        name: "iconColor",
        callback: vm.setMinHeight,
      });

      // parallax
      this.$refs["parallax"].setValues({
        parallaxActive: vm.config.parallaxActive,
        parallaxEffect: vm.config.parallaxEffect,
        parallaxSpeed: vm.config.parallaxSpeed,
        element: null,
        labelDesc: "parallax",
        name: "parallax",
        callback: vm.setParallax,
      });

      //video
      this.$refs["video"].setValues({
        defaultValue: vm.config.video,
        defaultValueInternal: vm.config.videoInternal,
        defaultValueAutoplay: vm.config.autoplay,
        defaultValueMuted: vm.config.muted,
        defaultValueLoop: vm.config.loop,
        labelDesc: "bg-video",
        canRemove: true,
        name: "video",
        callback: vm.setVideo,
      });

      //divider
      this.$refs["divider"].setValues({
        separatorActive: vm.config.separatorActive,
        separatorEffect: vm.config.separatorEffect,
        separatorColorsFirst: vm.config.separatorColors.first,
        separatorColorsSecond: vm.config.separatorColors.second,
        separatorColorsThird: vm.config.separatorColors.third,
        separatorColorsFourth: vm.config.separatorColors.fourth,
        separatorValueFirst: vm.config.separatorColors.value1,
        separatorValueSecond: vm.config.separatorColors.value2,
        separatorValueThird: vm.config.separatorColors.value3,
        separatorValueFourth: vm.config.separatorColors.value4,
        custom: vm.config.separatorColors.custom,
        labelDesc: "divider",
        name: "divider",
        callback: vm.setDivider,
      });

      // border
      this.$refs["border"].setValues({
        defaultValue: vm.config.border,
        borderWidth: vm.config.borderWidth,
        labelDesc: "border",
        name: "border",
        callback: vm.setBorder,
      });
      this.$refs["borderRadius"].setValues({
        defaultValue: vm.config.borderRadius,
        labelDesc: "borderRadius",
        name: "borderRadius",
        callback: vm.setBorderRadius,
      });

      // tag
      this.$refs["tag"].setValues({tag: vm.config.tag, callback: vm.setTag});

      //background options
      this.$refs["backgroundColor"].setValues({
        defaultValue: vm.config.backgroundColor,
        gradient: true,
        labelDesc: "bg-color",
        name: "backgroundColor",
        callback: vm.setBackgroundColor,
      });
      this.$refs["overlayColor"].setValues({
        defaultValue: vm.config.overlayColor,
        gradient: true,
        labelDesc: "overlay-color",
        name: "overlayColor",
        callback: vm.setOverlayColor,
      });
      this.$refs["buttonColor"].setValues({
        defaultValue: vm.config.buttonColor,
        gradient: false,
        labelDesc: "button-color",
        name: "buttonColor",
        callback: vm.setButtonColor,
      });
      this.$refs["buttonIcon"].setValues({
        defaultValue: vm.config.buttonIcon,
        gradient: false,
        labelDesc: "icon-color",
        name: "buttonIcon",
        callback: vm.setButtonIcon,
      });
      this.$refs["internalBackgroundColor"].setValues({
        defaultValue: vm.config.internalBackgroundColor,
        gradient: true,
        labelDesc: "bg-color",
        name: "internalBackgroundColor",
        callback: vm.setInternalBackgroundColor,
      });
      this.$refs["backgroundImage"].setValues({
        defaultValue: vm.config.backgroundImage,
        defaultValueOrigin: vm.config.backgroundOrigin,
        defaultValueRepeat: vm.config.backgroundRepeat,
        defaultValueSize: vm.config.backgroundSize,
        defaultValueAttachment: vm.config.backgroundAttachment,
        defaultValuePosition: vm.config.backgroundPosition,
        canExternal: true,
        canRemove: true,
        callback: vm.setBackgroundImage,
      });

      this.$refs["internalBackgroundImage"].setValues({
        defaultValue: vm.config.internalBackgroundImage,
        defaultValueOrigin: vm.config.internalBackgroundOrigin,
        defaultValueRepeat: vm.config.internalBackgroundRepeat,
        defaultValueSize: vm.config.internalBackgroundSize,
        defaultValueAttachment: vm.config.internalBackgroundAttachment,
        defaultValuePosition: vm.config.internalBackgroundPosition,
        canExternal: true,
        canRemove: true,
        callback: vm.setInternalBackgroundImage,
      });

      this.getHiddenValues();

    },
    removeEnabledTag(index) {
      this.config.enabled_tags.splice(index, 1);
      console.log(this.config.enabled_tags);
      this.save();

    },
    addTagPanel() {
      let obj = {
        column: this.enable_tags.column,
        operator: this.enable_tags.operator,
        value: this.enable_tags.value,
      }

      this.config.enabled_tags.push(obj)
      this.save();

      this.enable_tags.column = '';
      this.enable_tags.operator = 'equal';
      this.enable_tags.value = '';
    },
    toggleEnableTags(value) {
      this.config.enable_tags = value;
      this.save();
    },
    toggleColuns(value) {
      this.config.columns = value;
      this.save();
    },
    setAnchor(data) {
      this.config.anchorActive = data.anchorActive;
      this.config.anchorName = data.anchorName;

      this.save();
    },
    setArrow(data) {
      this.config = _.merge(this.config, data);
      this.save();
    },
    setHide() {
      this.config.hidePanel = !this.config.hidePanel;
      this.save();
    },
    setinfiniteSliderAnimation() {
      let vm = this;
      vm.config.infiniteSliderAnimation = this.infiniteSlider;
      this.save();
    },
    setHideTime() {
      if (this.minutesSaved > 360) {
        this.minutesSaved = 360;
      }
      if (this.minutesSaved < 0) {
        this.minutesSaved = 0;
      }
      if (this.secondsSaved > 60) {
        this.secondsSaved = 59;
      }
      if (this.secondsSaved < 0) {
        this.secondsSaved = 1;
      }

      this.config.unitsHidePanel = "seconds";
      this.config.timeHidePanel = this.minutesSaved * 60 + this.secondsSaved;

      this.save();
      this.$snotify.success(this.$t("ct-saved-successfully"));
    },
    getHiddenValues() {
      if (!this.config.hidePanel) return;

      if (this.config.unitsHidePanel == "minutes")
        this.config.timeHidePanel *= 60;

      this.minutesSaved = Math.floor(this.config.timeHidePanel / 60);
      this.secondsSaved = this.config.timeHidePanel % 60;
    },
    setHideName() {
      let vm = this;
      if (
        vm.config.nameHidePanel === "name-hide-panel" ||
        vm.config.nameHidePanel === ""
      ) {
        vm.config.nameHidePanel = `panel-${new Date().getTime() / 1000}`;
      }
      vm.config.nameHidePanel = vm.config.nameHidePanel.replace(
        /[^\w\s]/gi,
        ""
      );
      if (
        vm.config.nameHidePanel === "name-hide-panel" ||
        vm.config.nameHidePanel === ""
      ) {
        vm.config.nameHidePanel = `panel-${new Date().getTime() / 1000}`;
      }
      vm.config.nameHidePanel = vm.config.nameHidePanel.replace(
        /[^\w\s]/gi,
        ""
      );

      this.$snotify.success(this.$t("ct-saved-successfully"));
      this.save();
    },
    setFixed() {
      let vm = this;
      vm.config.fixed = this.fixedActive;
      vm.config.fixedMobile = this.fixedMobileActive;
      this.save();
    },
    setHeight(value) {
      this.config.height = `${value}px`;
      this.save();
    },
    setMinHeight(value) {
      this.config.minHeight = `${value}px`;
      this.save();
    },
    setBorder(data) {
      this.config.borderWidth = data.width;
      this.config.border = `${data.size}px ${data.style} ${data.color}`;
      this.save();
    },
    setBorderRadius(data) {
      this.config.borderRadius = data.value;
      this.save();
    },
    setVideo(obj) {
      this.config = _.merge(this.config, obj);
      this.save();
    },
    setTag(value) {
      this.config.tag = value;
      this.save();
    },
    setParallax(data) {
      this.config = _.merge(this.config, data);
      this.save();
    },
    setDivider(obj) {
      this.config = _.merge(this.config, obj);
      this.save();
    },
    setInternalBackgroundColor(value) {
      this.config.internalBackgroundColor = value;
      this.save();
      let vm = this;

      setTimeout(function () {
        vm.makePanelsToOrder();
      }, 1000);
    },
    setOverlayColor(value) {
      this.config.overlayColor = value;
      this.save();
    },
    setButtonColor(value) {
      this.config.buttonColor = value;
      this.save();
    },
    setButtonIcon(value) {
      this.config.buttonIcon = value;
      this.save();
    },
    setBackgroundColor(value) {
      this.config.backgroundColor = value;
      this.save();
      let vm = this;

      setTimeout(function () {
        vm.makePanelsToOrder();
      }, 1000);
    },
    setBackgroundImage(data) {
      if (data.type === "setImage") {
        this.config.backgroundColor = "white";
        this.config.backgroundImage = data.src;
      }

      if (data.type === "removeImage") {
        this.config.backgroundImage = "none";
      }

      if (data.type === "setConfig") {
        this.config.backgroundColor = "white";
        this.config.backgroundPosition = data.position;
        this.config.backgroundSize = data.size;
        this.config.backgroundRepeat = data.repeat;
        this.config.backgroundOrigin = data.origin;
        this.config.backgroundAttachment = data.attachment;
      }

      this.save();
      let vm = this;
      setTimeout(function () {
        vm.makePanelsToOrder();
      }, 1000);
    },
    setInternalBackgroundImage(data) {
      if (data.type === "setImage") {
        this.config.internalBackgroundColor = "white";
        this.config.internalBackgroundImage = data.src;
      }

      if (data.type === "removeImage") {
        this.config.internalBackgroundImage = "none";
      }

      if (data.type === "setConfig") {
        this.config.internalBackgroundColor = "white";
        this.config.internalBackgroundPosition = data.position;
        this.config.internalBackgroundSize = data.size;
        this.config.internalBackgroundRepeat = data.repeat;
        this.config.internalBackgroundOrigin = data.origin;
        this.config.internalBackgroundAttachment = data.attachment;
      }

      this.save();
      let vm = this;
      setTimeout(function () {
        vm.makePanelsToOrder();
      }, 1000);
    },
    save() {
      this.callback(this.config);
    },
  },
  beforeDestroy() {
    this.config = {};
    this.sortable = false;
    this.panelsToMove = [];
    this.callback = () => {
    };
  },
};
</script>

<style lang="scss" scoped>
ul {
  padding: 0;
}

.sortable-child-reorder {
  font-family: "Muli", sans-serif;
  font-size: 14px;
  text-transform: capitalize;

  list-style: none;
  color: #818181;
  padding: 10px;

  transition: background 0.3s;

  cursor: grab;

  svg {
    margin-right: 20px;
  }

  i {
    color: #0080FC;
  }

  &.hidden-elements {
    i {
      color: #808182;
    }
  }

  &:hover {
    background-color: #F4F4F4;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Panel/Options.vue